import React, { useEffect } from "react";
import { useNavigate } from "react-router";

const PaymentSuccessPopup = ({ onClose }) => {
  const navigate = useNavigate();

  // Prevent background scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleDashboardClick = () => {
    onClose();
    navigate("/dashboard");
  };

  const handleDetailsClick = () => {
    onClose();
    navigate("/pricing");
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm"
      onClick={handleOutsideClick}
    >
      <div className="relative bg-white rounded-2xl shadow-xl border border-gray-200 max-w-md w-full mx-4 p-8 animate-scale-in">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Animated checkmark circle */}
        <div className="relative mb-6">
          <div className="w-24 h-24 bg-purple-100 rounded-full flex items-center justify-center animate-pulse mx-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-14 w-14 text-purple-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <div className="absolute inset-0 rounded-full bg-purple-200 opacity-0 animate-ping"></div>
        </div>

        {/* Content */}
        <h2 className="text-3xl font-bold text-gray-800 mb-2 text-center">
          Payment <span className="text-purple-600">Successful!</span>
        </h2>

        <p className="text-lg text-gray-600 mb-4 text-center">
          You have activated your subscription.
        </p>

        {/* <div className="w-full bg-purple-50 rounded-lg p-4 mb-6 border border-purple-100">
          <p className="text-purple-800 font-medium text-center">
            Enjoy creating beautiful melodies!
          </p>
        </div> */}

        <button
          className="w-full max-w-xs px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-500 hover:from-purple-700 hover:to-purple-600 text-white font-semibold rounded-lg shadow-md transition-all duration-300 mx-auto block"
          onClick={() => navigate("/")}
        >
          Go to Dashboard
        </button>

        {/* Additional options */}
        {/* <div className="mt-6 pt-4 border-t border-gray-100 text-center w-full">
          <button
            onClick={handleDetailsClick}
            className="text-purple-600 hover:text-purple-800 text-sm font-medium"
          >
            View Subscription Details →
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default PaymentSuccessPopup;